import React from 'react'
import CandidateDetails from '../candidate-details'
import styles from '../../candidate.module.css'

const EditCandidateView = () => (
    <div className={styles.content}>
        <CandidateDetails />
    </div>
)

export default EditCandidateView
